export default __webpack_public_path__ + "static/media/mobile-devices.890afe15.png";